import { render, staticRenderFns } from "./cities.vue?vue&type=template&id=79764940&"
import script from "./cities.vue?vue&type=script&lang=js&"
export * from "./cities.vue?vue&type=script&lang=js&"
import style0 from "./cities.vue?vue&type=style&index=0&id=79764940&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconArrow: require('/opt/yamal.ru/src/components/icon/arrow.vue').default})
